import { memo } from 'react';

import PromptIconSVG from '@/assets/prompt-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IPromptIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={PromptIconSVG} {...props} />;

export const PromptIcon = memo(IPromptIcon) as typeof IPromptIcon;
